/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { itemTheme } from './styles'

const PickerToggle = ({ theme, mode, selectMode }) => (
  <ul className={styles.wrapper}>
    <li className={cx(styles.item, mode === 'date' && itemTheme(theme))} onClick={() => selectMode('date')}>
      Date
    </li>
    <li className={cx(styles.item, mode === 'time' && itemTheme(theme))} onClick={() => selectMode('time')}>
      Time
    </li>
  </ul>
)

PickerToggle.propTypes = {
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  mode: PropTypes.string,
  selectMode: PropTypes.func,
}

export default PickerToggle
